var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex items-center" },
    [
      _c("icon-component", {
        attrs: { name: _vm.icon.name, fill: _vm.icon.fill },
      }),
      _c("div", { staticClass: "pl-2" }, [_vm._v(_vm._s(_vm.value) + "%")]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }